import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { toggleLineBanner } from './actions'

function mapStateToProps(state, hocProps) {
    return {
        show: state.getIn(['banner', 'line', hocProps.id, 'show'], true),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ toggleLineBanner }, dispatch)
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
